export const config = {
  apiUrl: "https://app.firestormfire.com",
  altImg: "images/no_avatar_profile.jpg",
  baseUrl: "https://app.firestormfire.com/",
  altInvImg: "images/inv_img.jpeg",
  mainUrl: "https://firestormfire.com",
  facebookAppId: "276876873001354",
  googleAppId:
    "578420642265-thal45rhm91d9k52hohukaiqqn092pcg.apps.googleusercontent.com",
  _api: path => {
    return config.apiUrl + "/api/" + path;
  },
  dsn: "https://926dccb17d394913a99d10bb627968b0@o432627.ingest.sentry.io/5669506"
};

// export const config = {
//   apiUrl: "http://localhost:8000", // development
//   s3BucketUrl: "https://firestormfire.sfo2.cdn.digitaloceanspaces.com/",
//   assetUrl: "https://firestormfire.sfo2.cdn.digitaloceanspaces.com/dev/assets/",
//   altImg: "images/no_avatar_profile.jpg",
//   baseUrl: "http://localhost:8000/",
//   altInvImg: "images/inv_img.jpeg",
//   mainUrl: "http://localhost:3000",// Firestormfire url for application form,
//   pusherKey: "05da6ba83fa8bbffbeeb",
//   pusherCluster: "ap2",
//     facebookAppId: "276876873001354",
//   googleAppId:
//     "578420642265-thal45rhm91d9k52hohukaiqqn092pcg.apps.googleusercontent.com",
//   _api: path => {
//     return config.apiUrl + "/api/" + path;
//   },
//   dsn: "https://926dccb17d394913a99d10bb627968b0@o432627.ingest.sentry.io/5669506"
// };

// export const config = {
//   apiUrl: "https://fireapp-dev.wrg-apps.com",
//   altImg: "images/no_avatar_profile.jpg",
//   baseUrl: "https://fireapp-dev.wrg-apps.com/",
//   altInvImg: "images/inv_img.jpeg",
//   mainUrl: "https://fireapp-dev.wrg-apps.com",
//   facebookAppId: "276876873001354",
//   googleAppId:
//     "578420642265-thal45rhm91d9k52hohukaiqqn092pcg.apps.googleusercontent.com",
//   _api: path => {
//     return config.apiUrl + "/api/" + path;
//   },
//  // dsn: "https://926dccb17d394913a99d10bb627968b0@o432627.ingest.sentry.io/5669506"
// };


